import React, {ReactNode, FunctionComponent} from "react";
import {useParams} from "react-router-dom";
import {styled} from "@reside/ui";

import {UseScrollSpy} from "../../../../hooks/useScrollSpy";
import {TemporaryHideChart} from "../../../../pages/page-reporting/TemporaryHideChart";
import {ReportingRow} from "../reporting-row";

type Props = Readonly<{
  id: string;
  title?: ReactNode;
  children: ReactNode;
  sectionItems?: ReadonlyArray<string>;
}>;

export const ReportingGroupRenderer = ({id, title, children}: Props) => {
  const {sectionId, chartId} = useParams<{
    sectionId?: string;
    chartId?: string;
  }>();
  const showTitle = Boolean(title) && !sectionId && !chartId;

  return (
    <UseScrollSpy id={id}>
      {({scrollSpyRef}) => (
        <div ref={scrollSpyRef}>
          <Group>
            {showTitle && <Title id={id}>{title}</Title>}
            <ReportingRow>{children}</ReportingRow>
          </Group>
        </div>
      )}
    </UseScrollSpy>
  );
};

export const ReportingGroup: FunctionComponent<Props> = ({
  id,
  title,
  children,
  sectionItems = [],
}) => (
  <TemporaryHideChart chartIds={[...sectionItems]}>
    <ReportingGroupRenderer title={title} id={id}>
      {children}
    </ReportingGroupRenderer>
  </TemporaryHideChart>
);

const Group = styled.div`
  & + & {
    margin-top: 64px;
  }
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: bold;
  width: 100%;
  padding: 24px 0;
`;
